import { useEffect } from "react";
import AOS from "aos";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import ContactFloat from "@/components/ContactFloat";
import IndustrySolutionSections from "@/components/IndustrySolutionSections";
import KnowledgeBaseMindMap from "@/components/KnowledgeBaseMindMap";

export default function ChargingPileSolutions() {
  const { t } = useTranslation();

  useEffect(() => {
    AOS.init({
      offset: 100,
      easing: "ease-out-back",
      duration: 1000,
      delay: 100,
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>{t("chargingPile.title")}</title>
        <meta name="keywords" content={t("chargingPile.keywords")} />
        <meta name="description" content={t("chargingPile.description")} />
      </Helmet>
      <ContactFloat />

      <section
        className="w-full bg-[#1a2d42]"
        data-aos="fade-right"
        data-aos-offset="100"
        data-aos-duration="500"
      >
        <div className="relative isolate h-[400px] w-full overflow-hidden">
          <img
            src="/solutions/charging-pile-banner.jpeg"
            alt=""
            className="absolute inset-0 h-full w-full object-cover object-[50%_12.5%]"
          />
          <div className="absolute inset-0 bg-linear-to-r from-[#0f1f30]/92 via-[#0f1f30]/72 to-transparent" />
          <div className="relative z-10 grid h-full w-1200 place-items-center px-4 text-center">
            <div>
              <h2
                className="text-[30px] leading-snug font-bold text-white"
                data-aos="fade-right"
                data-aos-offset="100"
                data-aos-duration="500"
              >
                {t("chargingPile.banner.title")}
              </h2>
              <span
                className="mx-auto mt-3 block h-[4px] w-[50px] bg-white"
                data-aos="zoom-in"
                data-aos-delay="300"
              />
              <p
                className="mt-5 text-base text-white/90 md:text-lg"
                data-aos="fade-left"
                data-aos-offset="100"
                data-aos-duration="500"
              >
                {t("chargingPile.banner.subtitle")}
              </p>
            </div>
          </div>
        </div>
      </section>

      <KnowledgeBaseMindMap
        rootLabel={t("chargingPile.knowledgeBase.rootLabel")}
        rootColor="#2563eb"
        treeTranslationKey="chargingPile.knowledgeBase.tree"
        i18nPrefix="chargingPile.knowledgeBase"
      />

      <IndustrySolutionSections
        i18nPrefix="chargingPile"
        images={{
          painPoints: "/solutions/charging-pile-pain.jpeg",
          solutions: "/solutions/charging-pile-solutions.jpeg",
          cta: "/solutions/charging-pile-cta.jpeg",
        }}
        imagesPos={{
          painPoints: "73% 24%",
          solutions: "55% 26%",
          cta: "50% 6%",
        }}
      />
    </>
  );
}
